module.exports = __webpack_public_path__ + "static/img/unifi-logo-new-with-text-green.391bc5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/unifi-logo-new-with-text-green.svg
// module id = /3q/
// module chunks = 1